import styled from 'styled-components'

export const DropdownButton = styled.div`
  position: relative;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  color: #6ec1e4;
  align-items: center;
  cursor: pointer;

  img {
    margin-left: 0.5rem;
  }
`

export const DropdownIconStyle = styled.img`
  width: 0.4rem;
  transition: transform 0.3s ease;

  &.active {
    transform: rotate(90deg);
  }
`

export const DropdownExibition = styled.div``
